import React from 'react'
import { Redirect } from 'react-router-dom'
import Snackbar from 'material-ui-legacy/Snackbar'
import ActionCompareArrows from 'material-ui-legacy/svg-icons/action/compare-arrows'
import ActionCheckCircle from 'material-ui-legacy/svg-icons/action/check-circle'
import { deepOrange500, lightGreenA700 } from 'material-ui-legacy/styles/colors'

import errors from '../../lib/errors.js'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import ErrorDialog from '../UI/ErrorDialog'
import QuoteForm from './QuoteForm'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')
const QuoteStore = Resource('quotes')

/*
MAIN COMPONENT -----------------------------------------------------------------

Props:
- projectId: Id of project for quote (also received via props.match.params)
- quoteId: id of the quote to be edited (also received via props.match.params)
- projectTypeId: Number, the projectTypeId
- projectTypeName: name of the project type
- quote: a complete quote object (can be used instead of quoteId)
- savedCallback(quote): callback function for sucessful save
- cancelCallback(): callback function for cancellation (default: history.back())
*/
class EditQuote extends React.PureComponent {
  constructor(props) {
    super(props)
    const { match, projectId, quoteId, quote } = this.props

    this.state = {
      projectId: projectId || match.params.projectId,
      quoteId: quoteId || match.params.quoteId,
      project: null,
      quote: quote,
      savedQuote: null,
      saved: false,
      changed: false,
      loading: true,
      error: null,
      snackbarMessage: '',
      redirect: null
    }
  }

  componentWillMount() {
    const { projectId, quoteId } = this.state

    const promises = [ProjectStore.find(projectId), QuoteStore.find(quoteId)]

    Promise.all(promises)
      .then(results => {
        const [projectResult, quoteResult] = results
        this.setState({
          project: projectResult.data,
          quote: quoteResult.data,
          loading: false,
          error: null
        })
      })
      .catch(error =>
        this.setState({
          project: null,
          loading: false,
          error: errors.unpack(error)
        })
      )
  }

  _save = attributes => {
    const { savedCallback } = this.props
    const { project, quote } = this.state

    // Adjust attributes
    attributes.projectId = project.id
    attributes.cloned = false

    // Update!
    QuoteStore.update(quote.id, attributes)
      .then(result => {
        const savedQuote = result.data.data
        this.setState(
          {
            saved: true,
            changed: false,
            error: null,
            savedQuote: savedQuote,
            snackbarMessage: `Quote "${attributes.name}" saved!`
          },
          () => {
            if (savedCallback) savedCallback(savedQuote)
          }
        )
      })
      .catch(error => {
        this.setState({
          saved: false,
          error: errors.unpack(error)
        })
      })
  }

  _cancel = () => {
    const { cancelCallback } = this.props
    if (!cancelCallback) return window.history.back()
    cancelCallback()
  }

  _changed = didChange => this.setState({ changed: didChange, saved: false })

  _closeErrorDialog = () => this.setState({ error: null })

  _resetSnackbar = () => this.setState({ snackbarMessage: '' })

  _redirectTo = url => this.setState({ redirect: url })

  render() {
    const {
      project,
      quote,
      loading,
      changed,
      saved,
      error,
      snackbarMessage,
      redirect
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect} />

    const projectTypeId =
      project.attributes.projectTypeId || this.props.projectTypeId

    const projectTypeName = project.attributes.projectTypeName
    
    return (
      <section>
        <PageTitle>
          Editing quote&nbsp;
          <h3>
            Project #{project.id}: {project.attributes.name}
            &nbsp;
          </h3>
          <div>
            {changed && <ActionCompareArrows color={deepOrange500} />}
            {saved && <ActionCheckCircle color={lightGreenA700} />}
          </div>
        </PageTitle>

        <QuoteForm
          quote={quote}
          projectTypeId={projectTypeId}
          projectTypeName={projectTypeName}
          budget={project.attributes.budget}
          estimatedCost={project.attributes.estimatedCost}
          targetMargin={project.attributes.targetMargin}
          changedCallback={this._changed}
          submitCallback={this._save}
          cancelCallback={this._cancel}
          noVersionMangling
        />

        <BackButton style={{ margin: '15px auto 100px auto' }} />
        <BackButton
          style={{ margin: '15px auto 100px 15px' }}
          label="Project page"
          onTouchTap={() => this._redirectTo(`/projects/${project.id}`)}
        />

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't save your changes"
        >
          <p>
            The quote <strong>{quote.attributes.fullName}</strong> remains
            unchanged.
          </p>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(snackbarMessage)}
          message={snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />
      </section>
    )
  }
}

export default EditQuote



// WEBPACK FOOTER //
// ./src/components/Quotes/EditQuote.jsx